module.exports = __webpack_public_path__ + "static/media/bell-icon.a435c7d3.svg";